import React from 'react';
import { useTranslation } from 'react-i18next';
import AdherenceSettingsQueueLimitTable from 'components/molecules/adherence-settings/queue-limit-table';

import s from './styles.module.scss';

const AdherenceSettingsQueueLimitsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <h1 className={s.title}>{t('links.queueLimits')}</h1>
      <AdherenceSettingsQueueLimitTable />
    </div>
  );
};

export default AdherenceSettingsQueueLimitsPage;
